import { render, staticRenderFns } from "./videoDetail.vue?vue&type=template&id=60fd4a9d&scoped=true"
import script from "./videoDetail.vue?vue&type=script&lang=js"
export * from "./videoDetail.vue?vue&type=script&lang=js"
import style0 from "./videoDetail.vue?vue&type=style&index=0&id=60fd4a9d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd4a9d",
  null
  
)

export default component.exports